import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  foo?: boolean;
}

const Input: React.FC<InputProps> = ({ type = 'text', value, className, onChange, ...otherProps }) => {
  const [innerValue, setValue] = useState(value || '');

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange?.(e);
    setValue(e.target.value);
  };

  useEffect(() => {
    if (value !== undefined) {
      setValue(value);
    }
  }, [value]);

  return (
    <input
      type={type}
      className={classNames(styles.input, className)}
      value={innerValue}
      onChange={handleChange}
      {...otherProps}
    />
  );
};

export default Input;
